import { isAxiosError } from "axios";

/** Stable domain codes, never prose or provider failure strings. */
export function creativeSaveErrorKey(
  error: unknown,
): "creativeLibrary.identityMismatch" | "creativeLibrary.saveFailed" {
  return isAxiosError(error) &&
    error.response?.data?.code === "creative_reference_identity_mismatch"
    ? "creativeLibrary.identityMismatch"
    : "creativeLibrary.saveFailed";
}
